/**
 * @generated SignedSource<<007158daaa8c3105411966c78d3d7ae5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ToolCallsSection_toolCalls$data = ReadonlyArray<{
  readonly text: string;
  readonly thinking: string | null | undefined;
  readonly toolResult: {
    readonly artifactId: string | null | undefined;
    readonly groupTags: ReadonlyArray<string> | null | undefined;
  } | null | undefined;
  readonly toolUse: {
    readonly displayName: string | null | undefined;
    readonly id: string;
    readonly input: {
      readonly __typename: "GenericToolInput";
      readonly rawInput: any;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ChecklistToolCallResult_toolCall" | "ToolCallButton_toolCall" | "ToolCallSheet_toolCall" | "V2ToolButton_toolCall">;
  readonly " $fragmentType": "ToolCallsSection_toolCalls";
}>;
export type ToolCallsSection_toolCalls$key = ReadonlyArray<{
  readonly " $data"?: ToolCallsSection_toolCalls$data;
  readonly " $fragmentSpreads": FragmentRefs<"ToolCallsSection_toolCalls">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ToolCallsSection_toolCalls",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thinking",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToolCallButton_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChecklistToolCallResult_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToolCallSheet_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "V2ToolButton_toolCall"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolUse",
      "kind": "LinkedField",
      "name": "toolUse",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "input",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rawInput",
                  "storageKey": null
                }
              ],
              "type": "GenericToolInput",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolResult",
      "kind": "LinkedField",
      "name": "toolResult",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "artifactId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupTags",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLMessageToolCall",
  "abstractKey": null
};

(node as any).hash = "763b398fc53a79cceee85c63a2588e3c";

export default node;
